export type SecurityRuleContext = {
  path: string;
  operation: 'get' | 'list' | 'create' | 'update' | 'delete' | 'write';
  requestResourceData?: any;
};

export class FirestorePermissionError extends Error {
  context: SecurityRuleContext;
  
  constructor(context: SecurityRuleContext) {
    const detailedMessage = `Firestore Security Rules denied the following request: ${JSON.stringify(context, null, 2)}`;
    super(detailedMessage);
    this.name = "FirestorePermissionError";
    this.context = context;
  }
}
